import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-promotion-conditions',
  templateUrl: './promotion-conditions.component.html',
  styleUrls: ['./promotion-conditions.component.scss']
})
export class PromotionConditionsComponent {

  @Input() set playerUUID(player_uuid:any) {
    this.player_uuid = player_uuid;
    this.init(player_uuid)
  };

  @Output() closeEvent = new EventEmitter<any>()  
  public player_uuid:any;
  public conditions:any = [];
  constructor(private http: HttpService) { }

  async init(player_uuid:any) {
    const rtn = await this.http.post("/admin/player/get/promotion/conditions", {player_uuid})
    this.conditions = rtn['promotion']
  }

  close() {
    this.closeEvent.emit(true)
  }
}
